import { Component, Input } from '@angular/core';

import { RankViewModel } from './scorecard-rank.metadata';

@Component({
    selector: 'cmps-scorecard-rank',
    template: `
        <div class="cmps-scorecard-rank--container">
            <span class="cmps-scorecard-rank--title-label">
                {{ titleLabel }}
            </span>
            <div
                *ngFor="let rank of data"
                class="cmps-scorecard-rank--slider-container"
            >
                <span
                    class="cmps-scorecard-rank--label"
                    [cmpsTooltipTrigger]="rank.titleName"
                    trigger="hover"
                >
                    {{ getDisplayLabel(rank.titleName) }}
                </span>
                <div class="cmps-scorecard-rank--slider-container-item">
                    <span class="cmps-scorecard-rank--max">
                        {{ rank.totalPositions }}
                    </span>

                    <div class="cmps-scorecard-rank--slider-track">
                        <span
                            class="cmps-scorecard-rank--slider-thumb"
                            [style.left.%]="
                                getSliderPosition(
                                    rank.rankResult,
                                    rank.totalPositions
                                )
                            "
                        >
                            {{ rank.rankResult }}
                        </span>
                    </div>
                    <span class="cmps-scorecard-rank--min">{{ min }}</span>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-rank',
    },
})
export class CmpsScorecardRankComponent {
    @Input() data: RankViewModel[];
    @Input() titleLabel: string;
    @Input() min: number;

    constructor() {
        this.min = 1;
    }

    getSliderPosition(rankResult: string, totalPositions: string): number {
        const rankResultNum = Number(rankResult);
        const totalPositionsNum = Number(totalPositions);

        if (isNaN(rankResultNum) || isNaN(totalPositionsNum)) {
            throw new Error(
                'Invalid input: rankResult and totalPositions must be valid numbers.',
            );
        }

        const buffer = 5;
        if (totalPositionsNum === 1 && rankResultNum === 1) {
            return 95;
        }

        if (rankResultNum === this.min) {
            return 100 - buffer;
        }

        if (rankResultNum === totalPositionsNum) {
            return buffer;
        }

        return (
            ((totalPositionsNum - rankResultNum) /
                (totalPositionsNum - this.min)) *
            100
        );
    }

    getDisplayLabel(label: string): string {
        return label.length > 20 ? label.substring(0, 17) + '...' : label;
    }
}
